import { connect } from "react-redux";

import SingleWeighSettingsModalComponent from "components/SingleWeighSettingsModal";

export default connect()(SingleWeighSettingsModalComponent);
